import React from "react";
import { usePageTitle } from "../../Hooks/usePageTitle";

const TAGS = { 1: "h1", 2: "h2", 3: "h3" };

function PageHeading({
  level = 1,
  className,
  visuallyHidden = false,
  documentTitle,
  id,
  children,
}) {
  const Tag = TAGS[level] || "h1";
  usePageTitle(
    documentTitle ?? (typeof children === "string" ? children : undefined),
  );

  const classes = [
    "page-heading",
    visuallyHidden && "visually-hidden",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Tag id={id} className={classes} tabIndex={-1} data-page-heading="">
      {children}
    </Tag>
  );
}

export default PageHeading;
